///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-interactive.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import IReportEmployee = Meevo.Plugins.Reports.IReportEmployee;

    export class LoggedInEmployeeOnlyFilter extends InteractiveFilter implements IInteractiveFilter {
        templateName: FilterTemplateNames;
        values: Dictionary<any>;

        private readonly loggedInUserId: string;

        constructor(options: IDataTemplateFilterOptions = {}) {
            super(options);

            this.loggedInUserId = options.loggedInUserId;
        }

        filter(employees: ISmartMoverModel<IReportEmployee>[]): ISmartMoverModel<IReportEmployee>[] {
            return employees.filter(employee => employee.id === this.loggedInUserId);
        }

    }
}